import React from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { InView } from 'react-intersection-observer'
import { highlightPin } from './features/pinsReducer'
import { loadStories } from './features/storiesReducer'
import { setCenter, setZoom } from './features/mapReducer'
import AssetFactory from './AssetFactory'
import RoomIcon from '@material-ui/icons/Room'
import { grey } from '@material-ui/core/colors'

function StoryCard(props, color, dispatch, exhibitZoom) {
  const { _id, assets, title, location, locationName } = props

  const nameStyle = {
    lineHeight: '1em',
    fontWeight: 700,
    color: color,
    paddingTop: 40,
    paddingBottom: 16,
    borderTop: '4px solid #EEEEEE',
  }

  const storyLocation = {
    paddingBottom: 16,
  }

  const storyAssets = assets.map(AssetFactory)


  return (
    <InView key={_id}
            threshold={ 0 }
            rootMargin={'0px 0px -45% 2px'}
            onChange={(inView, entry) => {
              if(inView){
                dispatch(highlightPin(_id))
                dispatch(setZoom(exhibitZoom + 2))
                dispatch(setCenter(location))
                dispatch(loadStories())
              }
            }}>
      <Card elevation={0}
            square={true}
      >
        <CardContent>
          <Typography variant="h4" >
            <div style={nameStyle}>{title}</div>
          </Typography>
          <Typography style={storyLocation} variant="body2" color="textPrimary" component="p">
            <RoomIcon fontSize="small" style={{ color: grey[500] }} />{ locationName }
          </Typography>
          { storyAssets }
        </CardContent>
      </Card>
    </InView>
  )
}

export default StoryCard
